'use client';

import type { ReactNode } from 'react';
import { FileWriteRenderer } from '../../ToolCallsRenderers/renderers/FileWriteRenderer';
import { PlainTextRenderer } from '../../ToolCallsRenderers/renderers/PlainTextRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

export const renderFileWriteResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight } = ctx;

  if (typeof content === 'object' && content !== null) {
    return (
      <FileWriteRenderer
        data={content as { filePath?: string; content?: string }}
        maxHeight={maxHeight}
      />
    );
  }

  return <PlainTextRenderer content={String(content)} maxHeight={maxHeight} />;
};
